import React from 'react';
import styled, { keyframes } from 'styled-components';
import { formatDate, convertToUTC } from '../../helpers';
import { Alert } from '../Common';
import Cookies from 'js-cookie';

const slideIn = keyframes`
from {
	transform: translateY(-20px);
}
to {
	transform: translateY(0);
}
`;

const Container = styled.div`
	position: fixed;
	width: 200px;
	top: 20px;
	right: 20px;
	animation: ${slideIn} 0.2s ease-out;
`;

class AdminNotifications extends React.Component {
	// Set a cookie that a notification has been read with one week expiration
	markAsRead = notificationId => {
		Cookies.set(`readAdminNotification_${notificationId}`, 1, {
			expires: 30,
		});

		// Because setting cookies does not rerender component,
		// force update when marking a notification as read
		this.forceUpdate();
	};

	render() {
		const { notifications = [] } = this.props;

		if (!notifications || notifications.length < 1) return null;

		const now = formatDate(convertToUTC(new Date()), true);

		const notificationsToShow = notifications.filter(notification => {
			const hasBeenRead = Cookies.get(
				`readAdminNotification_${notification.id}`
			);

			return !hasBeenRead && notification.from <= now && notification.to > now;
		});

		return (
			<Container>
				{notificationsToShow.map(notification => (
					<Alert
						key={notification.id}
						type={notification.type}
						close={() => this.markAsRead(notification.id)}
						className="mt10"
					>
						{notification.message}
					</Alert>
				))}
			</Container>
		);
	}
}

export default AdminNotifications;



// WEBPACK FOOTER //
// ./src/components/AdminNotifications/AdminNotifications.js